import LoadingButton from '@mui/lab/LoadingButton'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined'

export function SaveButton({ label, loading }: { label: string; loading?: boolean }) {
  return (
    <LoadingButton
      type="submit"
      loading={loading}
      variant="contained"
      fullWidth
      size="large"
      endIcon={<CheckCircleOutlineIcon />}
      sx={{
        py: 1.75,
        fontWeight: 700,
        letterSpacing: '0.08em',
        borderRadius: 2,
        textTransform: 'uppercase',
        bgcolor: 'primary.main',
        boxShadow: 2,
        '&:hover': { bgcolor: 'primary.dark' },
      }}
    >
      {label}
    </LoadingButton>
  )
}
